// @flow
import { createRef, useState } from "react";
import { TextInput, ADDRESS_NOT_FOUND_ID } from "@nested/brand";
import { useSelector } from "react-redux";
import { Heading, QuestionWrapper } from "../components";
import { useDesktopFocus } from "../hooks/useDesktopFocus";
import { type QuestionProps } from "../components/MultiStageForm";
import { validatePresence } from "./validators";

const validate = async (value = {}) => {
  const lineOne = await validatePresence("lineOne")(value?.lineOne);
  const city = await validatePresence("city")(value?.city);

  return { ...lineOne, ...city };
};

export const ManualAddress = ({
  ActionButtons,
  BackButton,
  initialValue,
  next,
  validationErrors,
}: QuestionProps<"manualAddress">) => {
  const [lineOne, setLineOne] = useState(initialValue?.lineOne || "");
  const [lineTwo, setLineTwo] = useState(initialValue?.lineTwo || "");
  const [city, setCity] = useState(initialValue?.city || "");

  const ref = createRef();
  useDesktopFocus(ref);

  const {
    address: { postcode },
  } = useSelector((state) => state.onboardingForm);

  return (
    <QuestionWrapper
      next={() =>
        next(
          { id: ADDRESS_NOT_FOUND_ID, lineOne, lineTwo, city, postcode },
          validate,
        )
      }
      dataTest="manual-address-entry"
    >
      <BackButton />
      <Heading>What's your full address?</Heading>
      <TextInput
        className="fs-exclude"
        data-test="onboarding-form:manual-address-line-one"
        errorMessage={validationErrors.lineOne}
        hasErrors={Boolean(validationErrors.lineOne)}
        onChange={(e) => setLineOne(e.target.value)}
        placeholder="Address line one"
        ref={ref}
        type="text"
        value={lineOne}
      />
      <TextInput
        css="margin-top: 30px;"
        data-test="onboarding-form:manual-address-line-two"
        onChange={(e) => setLineTwo(e.target.value)}
        errorMessage={validationErrors.lineTwo}
        hasErrors={Boolean(validationErrors.lineTwo)}
        placeholder="Address line two (optional)"
        type="text"
        value={lineTwo}
      />
      <TextInput
        css="margin-top: 30px;"
        data-test="onboarding-form:manual-address-city"
        errorMessage={validationErrors.city}
        hasErrors={Boolean(validationErrors.city)}
        onChange={(e) => setCity(e.target.value)}
        placeholder="Town or city"
        type="text"
        value={city}
      />
      <TextInput
        css="margin-top: 30px;"
        data-test="onboarding-form:manual-address-postcode"
        onChange={() => undefined}
        placeholder="Postcode"
        disabled
        type="text"
        value={postcode}
      />
      <ActionButtons />
    </QuestionWrapper>
  );
};
